import { render, staticRenderFns } from "./ResigQuery.vue?vue&type=template&id=f97e2d60&scoped=true&"
import script from "./ResigQuery.vue?vue&type=script&lang=js&"
export * from "./ResigQuery.vue?vue&type=script&lang=js&"
import style1 from "./ResigQuery.vue?vue&type=style&index=1&id=f97e2d60&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97e2d60",
  null
  
)

export default component.exports